import React from "react";

import {PayMethodType} from "store/post-results-services/postResultsServicesApi";

import {Button, Segment} from "@britishcouncil/react-extro-ui";

import * as S from "./SelectPaymentMainSection.styles";

interface PayMethodProps {
    selected: boolean;
    title: string;
    subtitle: string;
    payMethod: PayMethodType;
    onSelected: (payMethod: PayMethodType) => void;
    description?: React.ReactNode,
    buttonText: string;
    blockAction: boolean,
    onAction: () => void;
}

export const PayMethod = ({
                              selected,
                              title,
                              subtitle,
                              payMethod,
                              onSelected,
                              description,
                              buttonText,
                              blockAction,
                              onAction,
                          }: PayMethodProps) => {
    return (
        <S.PayMethodContainer>
            <Segment selectable={true} color={selected ? 'blue' : 'white'} elevation={2} selected={selected}>
                <S.Header>
                    <S.Radio
                        name='paymethod'
                        label={title}
                        value={selected}
                        onChange={() => onSelected(payMethod)}
                    />
                    <span className="subtitle">{subtitle} </span>
                </S.Header>

                {selected &&
                    <>
                        {description &&
                            <>
                                <S.Divider/>
                                <S.DescriptionContainer>
                                    {description}
                                </S.DescriptionContainer>
                            </>}
                        <Button className="payButton" borderRadius="rounded" onClick={onAction} disabled={blockAction}>{buttonText}</Button>
                    </>

                }

            </Segment>
        </S.PayMethodContainer>
    )
}